import { render, staticRenderFns } from "./question-1.vue?vue&type=template&id=0246e47e&scoped=true"
import script from "./question-1.vue?vue&type=script&lang=js"
export * from "./question-1.vue?vue&type=script&lang=js"
import style0 from "./question-1.vue?vue&type=style&index=0&id=0246e47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0246e47e",
  null
  
)

export default component.exports